module.exports = __webpack_public_path__ + "img/reimtotal.c0934d65.svg";